import { useContext } from "react";

import { DescriptionGroupContext, DescriptionGroupContextType } from "./DescriptionGroupContext";

export const useDescriptionGroup = (): DescriptionGroupContextType => {
  const context = useContext(DescriptionGroupContext);
  if (!context) {
    throw new Error("useDescriptionGroup must be used within an DescriptionGroupProvider");
  }
  return context;
};
